// BrainMath Web — application entry point.
//
// This file does three things and nothing else: pull in the configuration,
// stash a beta invite token if the URL carries one, and start the app.
// All behaviour lives in the modules imported below.
import { IS_LOCAL_DEVELOPMENT, PUBLIC_MAINTENANCE_MODE } from "./config.js";
import { restore } from "./data/account.js";
import { render } from "./router.js";
import { state } from "./state.js";
import { supabase } from "./supabase-client.js";
import { publicMaintenancePage } from "./views/auth.js";

supabase.auth.onAuthStateChange((_event, session) => {
  state.session = session;
});

if (!PUBLIC_MAINTENANCE_MODE && "serviceWorker" in navigator) {
  window.addEventListener("load", () => navigator.serviceWorker.register("/service-worker.js?v=55", {
    updateViaCache: "none"
  }));
}

if (PUBLIC_MAINTENANCE_MODE && !IS_LOCAL_DEVELOPMENT) {
  publicMaintenancePage();
} else {
  restore();
}

window.addEventListener("popstate", render);
